export enum CareplusPolicyStatus {
  PAYMENT_PENDING = "PAYMENT_PENDING",
  PAYMENT_DONE = "PAYMENT_DONE",
  PAYMENT_FAILED = "PAYMENT_FAILED",
  POLICY_ISSUED = "ISSUED",
  PAID = "PAID",
  BTIC_ISSUED = "BTIC_ISSUED",
}
